import { getCachedResource } from './resource-cache.service';

/**
 * @name CacheService
 *
 * @description Make requests to retrieve data while caching the results during your application's runtime
 *
 * @deprecated This service is deprecated and will be removed in the next major version. Use the `getCachedResource` or `createResourceCache` instead.
 *
 * @example
 * import { CacheService } from '@workbench/core';
 *
 * const cacheService = new CacheService();
 *
 * cacheService
 *   .get('https://url.com/contacts.json')
 *   .then(rawData => console.log(rawData))
 *   .catch(err => console.error(err));
 */
export class CacheService {
  // this class is just kept for backward compatibility
  public get(resource: string): Promise<any> {
    // the old implementation kinda worked like a singleton, so we just return the shared service to keep the same behavior
    return getCachedResource(resource);
  }
}
